import React, { useEffect, useState } from 'react'
import Quotes from './quotes'
import { IContainerProps } from './quotesinterface'
import { selectors as globalDataSelector } from "../../../state/features/common/globaldata";
import { selectors as headerSelector } from '../../../state/features/header';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../const/resource";
import helperfunctions from '../../../utils/helperfunctions';
import partsService from "../../../services/partsservice";
import { confirmDailog } from '../../ConfirmDailog';
import moment from 'moment';

const Quotescontainer = (props: IContainerProps) => {
    const [showsharedDetails, setshowsharedDetails] = useState(false);
    const gridRef = React.createRef<any>();
    const [mount, setMount] = useState({ flag: false, data: [] });

    const myQuoteTab = 'myquote';
    const sharedTab = 'shared';
    const archivetab = 'archive';

    const quoteShareclick = () => {
        setshowsharedDetails(true);
    };

    const { t } = useTranslation();
    const [showPopup, setShowPopup] = useState(false);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [errorSuccessMessage, setErrorSuccessMessage] = useState<string>("");
    const [alertType, setAlertType] = useState<string>("");
    const [tab, setTab] = useState<any>(myQuoteTab);
    const [gridData, setGridData] = useState<any>([]);
    const [isLoading, setIsLoading] = useState<any>(false);
    const [selectedItem, setSelectedItem] = useState<any>([]);
    const [selectedDetailItem, setSelectedDetailItem] = useState<any>({});
    const [deleteOrArchiveQuoteRes, setDeleteOrArchiveQuoteRes] = useState({ loading: false, data: {} });
    const [saveQuoteRes, setSaveQuoteRes] = useState({ loading: false, data: {} });
    const [addToCartQuoteRes, setAddToCartQuoteRes] = useState({ loading: false, data: {} });
    const [shareQuoteRes, setShareQuoteRes] = useState({ loading: false, data: {} });
    const [quoteDetailList, setQuoteDetailList] = useState<any>({ loading: false, data: {} });
    const [isShowSavePopup, setIsShowSavePopup] = useState(false);
    const [showShareAlert, setShowShareAlert] = useState(false);
    const [errorShareMsg, setErrorShareMsg] = useState('');
    const [isRedirect, setIsRedirect] = useState<any>(props.quoteId > 0);
    const [shareItem, setShareItem] = useState<any>(null);
    const [selectedKey, setSelectedKey] = useState<number>(0);
    const [redirectErrorMsg, setRedirectErrorMsg] = useState<string>("");
    const {
        headercurrentuser,
        globalData
    }: any = useSelector(
        state => ({
            headercurrentuser: headerSelector.currentuser(state),
            globalData: globalDataSelector.globaldata(state),
        })
    );

    useEffect(() =>
    {
        if (props.quoteId > 0) {
            getQuotesDetailDataForRedirect(props.quoteId);
        }
    }, [props.quoteId])

    useEffect(() => {
        if (showAlert) {
            setTimeout(() => {
                setShowAlert(false);
                setErrorSuccessMessage("");
                setAlertType("");
            }, 5000);
        }
    }, [showAlert]);

    useEffect(() => {
        setSelectedDetailItem(quoteDetailList?.data);
    }, [quoteDetailList?.data]);

    useEffect(() => {
        if (!isRedirect) {
            setSelectedItem([]);
            setGridData([]);
            getQuotesData();
            setshowsharedDetails(false);
        }
    }, [tab]);

    const handleAlertClose = () => {
        setShowAlert(false);
        setErrorSuccessMessage("");
        setAlertType("");
    }

    const handleRedirectAlertClose = () => {
        setRedirectErrorMsg("")
    }

    const quoteShareClick = () => {
        setshowsharedDetails(true);
    };

    const quoteShareClickBack = () => {
        setshowsharedDetails(false);
        setSelectedItem([]);
        setSelectedDetailItem({});
        getQuotesData();
    };

    const downloadAttachment = (data: any) => {
        if (data?.fileUrl)
        {
            window.open(data?.fileUrl, '_self');
        }
    }

    const getQuotesData = () => {
        setIsLoading(true);
        setGridData([]);
        const data = {
            quoteTab: tab,
            userAadId: headercurrentuser?.azureADId ?? '',
        }
        partsService.getQuoteList(data)
            .then((response: any) => {
                setIsLoading(false);
                const resultSet = response?.result?.map((item: any) => {
                    item["createdUTCDateExcel"] = item.createdUTCDate ? moment(item.createdUTCDate).format("MM/DD/YYYY") : "",
                    item["createdDate"] = item.createdUTCDate ? new Date(moment(item.createdUTCDate).format("MM/DD/YYYY")):""
                    return item
                }) ?? [];
                setGridData(resultSet);
            })
            .catch((e: any) => {
                setIsLoading(false);
                helperfunctions.showErrorMessage(e);
            });
    }

    const getQuotesDetailDataForRedirect = async (quoteId: number) => {
        setIsLoading(true);
        setQuoteDetailList({ loading: true, data: {} });
        let result: any = {};
        try {
            const req = {
                quoteId: quoteId,
                userAadId: headercurrentuser?.azureADId ?? '',
                distributorCode: globalData.DistributorCode ?? '',
                customerId: globalData.CustomerId ? parseInt(globalData.CustomerId) : 0,
                isFromNotificationLink : true
            }
            const response = await partsService.getQuotesDetailData(req);
            if (response?.isSuccess) {
                getQuotesDataForRedirect(quoteId, response);
                setSelectedKey(response?.data?.quote?.quoteStatus == 2 ? 2 : 0);
                setTab(response?.data?.quote?.quoteStatus == 2 ? archivetab : myQuoteTab);
                result = { loading: false, data: response?.data?.quoteList?.result ? { ...response?.data?.quote, quoteList: response?.data?.quoteList?.result } : {} };
            } else {
                setIsLoading(false);
                result = {
                    loading: false, data: {}
                };
            }

            setQuoteDetailList(result);
        } catch (error) {
            result = {
                loading: false, data: {}
            };
            setIsLoading(false);
            setQuoteDetailList(result);
        }
    }

    const getQuotesDataForRedirect = (quoteId: any, quoteData: any) => {
        const currentTab = quoteData?.data?.quote?.quoteStatus == 1 ? myQuoteTab : archivetab;
        const errMsg = quoteData?.data?.quote?.quoteMessage;
        setRedirectErrorMsg(errMsg);
        const data = {
            quoteTab: currentTab,
            userAadId: headercurrentuser?.azureADId ?? '',
        }
        if(errMsg) {
            getQuotesData();
            setIsRedirect(false);
            props.setQuoteId(0);
        } else {
            partsService.getQuoteList(data)
            .then((response: any) => {
                setIsLoading(false);
                const resultSet = response?.result?.find((item: any) => item.quoteId == quoteId) ?? {};
                setSelectedItem([resultSet]);
                setshowsharedDetails(true);
                setIsRedirect(false);
                props.setQuoteId(0);
            })
            .catch((e: any) => {
                setIsLoading(false);
                helperfunctions.showErrorMessage(e);
            });
        }
    }

    const getQuotesDetailData = async (quoteId: number) => {
        setQuoteDetailList({ loading: true, data: {} });
        let result: any = {};
        try {
            const req = {
                quoteId: quoteId,
                userAadId: headercurrentuser?.azureADId ?? '',
                distributorCode: globalData.DistributorCode ?? '',
                customerId: globalData.CustomerId ? parseInt(globalData.CustomerId) : 0,
                isFromNotificationLink : false
            }
            const response = await partsService.getQuotesDetailData(req);
            if (response?.isSuccess) {
                result = { loading: false, data: response?.data?.quoteList?.result ? { ...response?.data?.quote, quoteList: response?.data?.quoteList?.result } : {} };
            } else {
                result = {
                    loading: false, data: {}
                };
            }

            setQuoteDetailList(result);
        } catch (error) {
            result = {
                loading: false, data: {}
            };
            setQuoteDetailList(result);
        }
    };

    const showErrorMessage = (message: any) => {
        setErrorSuccessMessage(message);
        setShowAlert(true);
        setAlertType("error");
    };

    const getSelectedDetailItems = () => {
        const selectedDetailItemList = selectedDetailItem?.quoteList.filter((item: any) => item.checked === true);
        return selectedDetailItemList ?? []
    };

    const quoteSelectionValidation = (type: string) => {
        if (showsharedDetails) {
            if (type !== 'Archive' && type !== 'share') {
                const selectedDetailItemList = getSelectedDetailItems();
                if (!selectedDetailItemList?.length) {
                    showErrorMessage(t(RESOURCE.MyK_Label_SC_Quote_Parts_Selection_Validation));
                    return false;
                }
            } else {
                return true;
            }
        }
        else if (!selectedItem.length) {
            showErrorMessage(t(RESOURCE.MyK_Label_SC_Quote_Selection_Validation));
            return false;
        }
        return true;
    }

    const getFormattedData = () => {
        return selectedDetailItem?.quoteList
            .filter((item: any) => item.checked === true)
            .map((item: any) => ({
                detailId: item.id,
                itemQty: parseInt(item.partQty),
                quoteNumber: item.quoteId
            }));
    };

    const saveQuoteService = async (saveCartDetails: any) => {
        setSaveQuoteRes({ loading: true, data: [] });
        const quoteIds = selectedItem.map((item: any) => item?.userQuoteId).join(',');
        const formattedData = showsharedDetails ? getFormattedData() : [];

        const model = {
            quoteListName: saveCartDetails?.shoppingListName ?? '',
            quoteListType: saveCartDetails?.selectedListType ?? '',
            userAadId: headercurrentuser?.azureADId ?? '',
            isBulkQuote: !showsharedDetails,
            quoteId: quoteIds ?? '',
            partsList: formattedData,
            customerId: globalData.CustomerId ? parseInt(globalData.CustomerId) : 0,
            isQuoteSaved: true
        };

        partsService.savePartListForQuote(model)
            .then((response: any) => {
                setSaveQuoteRes({ loading: false, data: response });
                if (response.isSuccessful) {
                    props.getPartsListItems();
                    setSaveQuoteRes({ loading: false, data: response ?? {} });
                    if (showsharedDetails) {
                        getQuotesDetailData(selectedItem?.[0]?.quoteId);
                    }
                    else {
                        getQuotesData();
                    }
                    handleIsShowSavePopup(false);
                    helperfunctions.showSuccessMessage(`${t(RESOURCE.MyK_Label_ShoppingCart_saveQuote_Success_Msg)}`);
                }
                else {
                    setSaveQuoteRes({ loading: false, data: [] });
                    helperfunctions.showErrorMessage((response?.message ?? "") != "" ? response?.message : t(RESOURCE.MyK_Label_ShoppingCart_saveQuote_Error_Msg));
                }
            })
            .catch((e: any) => {
                setSaveQuoteRes({ loading: false, data: [] });
                helperfunctions.showErrorMessage(e);
            });
    }

    const handleIsShowSavePopup = (isShow: boolean) => {
        setIsShowSavePopup(isShow)
    };

    const saveQuote = () => {
        if (quoteSelectionValidation('save')) {
            handleIsShowSavePopup(true);
        }
    };

    const deleteOrArchiveQuoteService = async (type: string, model: any) => {
        const resourceKey: any = {
            'Archive': {
                success: t(RESOURCE.MyK_Label_ShoppingCart_ArchiveQuoteService_Success_Msg),
                error: t(RESOURCE.MyK_Label_ShoppingCart_ArchiveQuoteService_Error_Msg)
            },
            'Delete': {
                success:  showsharedDetails ? t(RESOURCE.MyK_Label_ShoppingCart_deletePartService_Success_Msg) : t(RESOURCE.MyK_Label_ShoppingCart_deleteQuoteService_Success_Msg),
                error:  showsharedDetails ? t(RESOURCE.MyK_Label_ShoppingCart_deletePartService_Error_Msg): t(RESOURCE.MyK_Label_ShoppingCart_deleteQuoteService_Error_Msg)
            }
        }
        setDeleteOrArchiveQuoteRes({ loading: true, data: [] });

        partsService.deleteOrArchiveQuote(model)
            .then((response: any) => {
                setDeleteOrArchiveQuoteRes({ loading: false, data: response });
                if (response.isSuccessful) {
                    if (showsharedDetails) {
                        if (type === 'Archive') {
                            quoteShareClickBack();
                        }
                        getQuotesDetailData(selectedItem?.[0]?.quoteId);
                    }
                    setSelectedItem([]);
                    getQuotesData();
                    helperfunctions.showSuccessMessage(`${resourceKey?.[type]?.success}`);
                }
                else {
                    setSaveQuoteRes({ loading: false, data: [] });
                    helperfunctions.showErrorMessage(response?.message ?? `${resourceKey?.[type]?.error}`);
                }
            })
            .catch((e: any) => {
                setDeleteOrArchiveQuoteRes({ loading: false, data: [] });
                helperfunctions.showErrorMessage(e);
            });
    }

    const deleteOrArchiveQuote = (type: any) => {
        const userQuoteIds = selectedItem.map((item: any) => item?.userQuoteId).join(',');
        const formattedData = showsharedDetails
            ? selectedDetailItem?.quoteList
                .filter((item: any) => item.checked === true)
                .map((item: any) => item?.partNumber).join(',')
            : "";

        const model = {
            selectedIds: userQuoteIds,
            selectedPartNumbers: type === 'Delete' ? formattedData : "",
            action: type,
            userAadId: headercurrentuser?.azureADId ?? '',
        };

        if (quoteSelectionValidation(type)) {
            const titleObj: any = {
                Archive: {
                    title: showsharedDetails ? t(RESOURCE.MyK_Label_SC_Archive_Quote) : t(RESOURCE.MyK_Label_SC_Archive_Quotes),
                    message: showsharedDetails ? t(RESOURCE.MyK_Label_SC_Archive_Quote_Confirm_Msg) : t(RESOURCE.MyK_Label_SC_Archive_Quotes_Confirm_Msg),
                },
                Delete: {
                    title: showsharedDetails ? t(RESOURCE.MyK_Label_SC_Delete_Quote) : t(RESOURCE.MyK_Label_SC_Delete_Quotes),
                    message: showsharedDetails ? t(RESOURCE.MyK_Label_SC_Delete_Quote_Confirm_Msg) : t(RESOURCE.MyK_Label_SC_Delete_Quotes_Confirm_Msg),
                }
            }
            const confimObject = {
                title: titleObj?.[type]?.title,
                message: titleObj?.[type]?.message,
                confirmmessage: '',
                buttonLabel: {
                    yes: t(RESOURCE.MyK_Label_Yes),
                    no: t(RESOURCE.MyK_Label_No),
                },
                yesOnclick: () => {
                    deleteOrArchiveQuoteService(type, model);
                },
                noOnclick: () => {
                },
            }
            confirmDailog(confimObject);
        }
    }

    const shareQuoteService = (tags: any) => {
        setShareQuoteRes({ loading: true, data: [] });
        const userQuoteId = (selectedItem?.length > 0 ? (selectedItem.map((t: any) => t.userQuoteId)?.join(",")) : (shareItem?.userQuoteId));
        const model = {
            userQuoteId: userQuoteId,
            sharedToUserEmail: tags?.map((t: any) => t.id)?.join(","),
            sharedByUserEmail: headercurrentuser?.eml,
            userAadId: headercurrentuser?.azureADId ?? '',
            sharedByUserFirstName: headercurrentuser?.fn,
            sharedByUserLastName: headercurrentuser?.ln
        }

        partsService.shareQuote(model)
            .then((response: any) => {
                setShareQuoteRes({ loading: false, data: response });
                if (response.isQuoteShared) {
                    openSharePopup();
                    if (showsharedDetails) {
                        getQuotesDetailData(selectedItem?.[0]?.quoteId);
                    }
                    else {
                        getQuotesData();
                    }
                    helperfunctions.showSuccessMessage(response?.sucessMessage ?? t(RESOURCE.MyK_Label_ShoppingCart_shareQuote_Success_Msg));
                }
                else {
                    setErrorShareMsg(response?.errorMessage ?? t(RESOURCE.MyK_Label_ShoppingCart_shareQuote_Error_Msg));
                    setShowShareAlert(true);
                }
            })
            .catch((e: any) => {
                setShareQuoteRes({ loading: false, data: [] });
                setErrorShareMsg(e);
                setShowShareAlert(true);
            });
    }

    const shareQuote = () => {
        if (quoteSelectionValidation('share')) {
            openSharePopup();
        }
    }

    const addToCartQuote = () => {
        if (quoteSelectionValidation('add')) {
            addToCart(showsharedDetails ? selectedDetailItem?.quoteList : selectedItem);
        }
    }

    const getFormattedParts = () => {
        return selectedDetailItem?.quoteList.reduce((acc: any, item: any): any => {
            if (item.checked) {
                acc.push({
                    manufacturer: {
                        code: item.manufacturer ?? "",
                        name: item.manufacturerName ?? ""
                    },
                    partNumber: item.partNumber,
                    quantity: item.partQty,
                    machine: {
                        mDbId: item?.machineId??0
                    }
                });
            }
            return acc;
        }, []);
    };

    const addToCartParts = () => {
        const model = {
            cart: {
                PunchoutOrderRequestId: globalData?.punchOutRequestPartLogId ?? 0,
                userAadId: headercurrentuser?.azureADId,
                distributorCode: globalData.DistributorCode,
                branchCode: globalData.BranchCode,
                customerId: globalData.CustomerId ? parseInt(globalData.CustomerId) : 0,
                locationId: globalData.LocationId ? parseInt(globalData.LocationId) : 0
            },
            parts: getFormattedParts()
        };

        partsService.addPartNumber(model)
            .then((response: any) => {
                if (response.isSuccessful) {
                    props?.getMiningParts();
                    setAddToCartQuoteRes({ loading: false, data: response?.data ?? {} });
                    props?.onRefresh(null, true);
                    if (showsharedDetails) {
                        getQuotesDetailData(selectedItem?.[0]?.quoteId);
                    }
                    helperfunctions.showSuccessMessage(response?.message ?? t(RESOURCE.MyK_Label_ShoppingCart_Add_Part_Success_Msg));
                }
                else {
                    setAddToCartQuoteRes({ loading: false, data: [] });
                    helperfunctions.showErrorMessage(response?.message ?? t(RESOURCE.MyK_Label_ShoppingCart_Add_Part_Error_Msg));
                }
            })
            .catch((e: any) => {
                setAddToCartQuoteRes({ loading: false, data: [] });
                helperfunctions.showErrorMessage(e);
            });
    }

    const addToCartData = async (data: any) => {
        setAddToCartQuoteRes({ loading: true, data: [] });
        if (showsharedDetails) {
            addToCartParts();
        } else {
            addToCartQuoteData(data);
        }
    };

    const addToCartQuoteData = (item: any) => {
        const model = {
            cartId: props?.cartsDetails?.cart?.cartId,
            userAadId: headercurrentuser?.azureADId,
            userQuoteId: item?.map((t: any) => t.userQuoteId)?.join(","),
            anonymousId: "",
            distributorCode: globalData.DistributorCode,
            branchCode: globalData.BranchCode,
            customerId: globalData.CustomerId ? parseInt(globalData.CustomerId) : 0,
            locationId: globalData.LocationId ? parseInt(globalData.LocationId) : 0
        };

        partsService.addToCartQuote(model)
            .then((response: any) => {
                if (response.isSuccessful) {
                    props?.getMiningParts();
                    setAddToCartQuoteRes({ loading: false, data: response?.data ?? {} });
                    props?.onRefresh(null, true);
                    getQuotesData();
                    helperfunctions.showSuccessMessage(response?.message ?? t(RESOURCE.MyK_Label_ShoppingCart_Add_Part_Success_Msg));
                }
                else {
                    setAddToCartQuoteRes({ loading: false, data: [] });
                    helperfunctions.showErrorMessage(response?.message ?? t(RESOURCE.MyK_Label_ShoppingCart_Add_Part_Error_Msg));
                }
            })
            .catch((e: any) => {
                setAddToCartQuoteRes({ loading: false, data: [] });
                helperfunctions.showErrorMessage(e);
            });
    }

    const addToCart = (data: any) => {
        setSelectedItem(data ?? []);
        const confimObject = {
            title: t(RESOURCE.MyK_Label_SC_Quote_Confirmation),
            message: t(RESOURCE.MyK_Label_SC_Quote_AddtoCart_Confirm_Msg),
            confirmmessage: '',
            buttonLabel: {
                yes: t(RESOURCE.MyK_Label_Yes),
                no: t(RESOURCE.MyK_Label_No),
            },
            yesOnclick: () => {
                addToCartData(data);
            },
            noOnclick: () => {
            },
        }
        confirmDailog(confimObject);
    }

    const share = (data: any) => {
        setSelectedItem(data ? [data] : []);
        setShareItem(data);
        openSharePopup();
    }

    const archiveQuote = (dataItem: any) => {
        setSelectedItem(dataItem ? [dataItem] : []);
        const model = {
            selectedIds: dataItem?.userQuoteId,
            selectedPartNumbers: "",
            action: "Archive",
            userAadId: headercurrentuser?.azureADId ?? '',
        };
        const confimObject = {
            title: showsharedDetails ? t(RESOURCE.MyK_Label_SC_Archive_Quote) : t(RESOURCE.MyK_Label_SC_Archive_Quotes),
            message: showsharedDetails ? t(RESOURCE.MyK_Label_SC_Archive_Quote_Confirm_Msg) : t(RESOURCE.MyK_Label_SC_Archive_Quotes_Confirm_Msg),
            confirmmessage: '',
            buttonLabel: {
                yes: t(RESOURCE.MyK_Label_Yes),
                no: t(RESOURCE.MyK_Label_No),
            },
            yesOnclick: () => {
                deleteOrArchiveQuoteService('Archive', model);
            },
            noOnclick: () => {
            },
        }
        confirmDailog(confimObject);
    }
    
    const selectAll = (e: any) => {
        if (e.target.checked) {
            setSelectedItem(gridData);
        }
        else {
            setSelectedItem([]);
        }
    }

    const onSelectionChange = (event: any, dataItem: any) => {
        if (event.target.checked) {
            const list = [...selectedItem, dataItem];
            setSelectedItem(list);
        }
        else {
            setSelectedItem((current: any) =>
                current.filter((t: any) => {
                    return t.quoteId !== dataItem.quoteId;
                }),
            );
        }
    };

    const handleLinkClick = (item?: any) => {
        let getVal = item?.props?.headerText;
        if (showsharedDetails) {
            quoteShareClickBack();
        }
        if (getVal == t(RESOURCE.MyK_Label_ShoppingCart_MyQuotes) && tab != myQuoteTab) {
            setTab(myQuoteTab);
            setSelectedKey(0);
        }
        else if (getVal == t(RESOURCE.MyK_Label_ShoppingCart_SharedQuotes) && tab != sharedTab) {
            setTab(sharedTab);
            setSelectedKey(1);
        }
        else if (getVal == t(RESOURCE.MyK_Label_ShoppingCart_Archive) && tab != archivetab) {
            setTab(archivetab);
            setSelectedKey(2);
        }
    };

    const excelExport = () => {
        setMount({ flag: true, data: gridRef?.current?.data ?? [] });
    };

    const openSharePopup = () => {
        if (showPopup) {
            setShareItem(null);
        }
        setErrorShareMsg("");
        setShowShareAlert(false);
        setShowPopup(!showPopup);
    }

    const onQuoteClick = async (item: any) => {
        const quote = item?.row ?? item;
        quoteShareclick();
        setSelectedItem([quote]);
        getQuotesDetailData(quote?.quoteId);
    }

    const onCommentChange = (inputValue: string) => {
        setSelectedDetailItem({ ...selectedDetailItem, comments: inputValue })
    }

    const updateCheckedItems = (isChecked: boolean, item: any) => {
        if (item) {
            const currentItem = item?.dataItem ?? {};
            const index = selectedDetailItem?.quoteList.findIndex((item: any) => item.id == currentItem?.id);
            if (index !== -1) {
                const updatedQuotesDetailsList = [...selectedDetailItem?.quoteList ?? []];
                updatedQuotesDetailsList[index] = {
                    ...updatedQuotesDetailsList[index],
                    checked: isChecked ?? false,
                };
                const obj = {
                    ...selectedDetailItem,
                    isSelectAll: false,
                    quoteList: updatedQuotesDetailsList,
                };
                setSelectedDetailItem(obj);
            }
        } else {
            const updatedQuotesDetailsList = [...selectedDetailItem?.quoteList ?? []];
            updatedQuotesDetailsList.forEach((item: any) => item['checked'] = isChecked)

            const obj = {
                ...selectedDetailItem,
                isSelectAll: isChecked,
                quoteList: updatedQuotesDetailsList,
            };
            setSelectedDetailItem(obj);
        }
    }

    const updateValue = (input: number, id: any) => {
        const index = selectedDetailItem?.quoteList.findIndex((item: any) => item.id == id);
        if (index !== -1) {
            const updatedQuotesDetailsList = [...selectedDetailItem?.quoteList ?? []];
            updatedQuotesDetailsList[index] = {
                ...updatedQuotesDetailsList[index],
                partQty: input,
            };

            const obj = {
                ...selectedDetailItem,
                quoteList: updatedQuotesDetailsList,
            };

            setSelectedDetailItem(obj);
        }
    }

    const onQuantityChange = (value: number, id: any) => {
        const input = value ?? 0;
        updateValue(input, id);
    };

    const incrementCount = (currentItem: any, id: any) => {
        const quantity = currentItem?.partQty ? Number(currentItem?.partQty) : 0;
        if (quantity <= 9999) {
            onQuantityChange((quantity + 1), id);
        }
    }

    const decrementCount = (currentItem: any, id: any) => {
        const quantity = currentItem?.partQty ? Number(currentItem?.partQty) : 0;
        if (quantity === 1) {
            onQuantityChange(1, id);
        } else {
            onQuantityChange((quantity - 1), id);
        }
    };

    return (
        <Quotes
            getCartItems={props?.getCartItems}
            gridRef={gridRef}
            mount={mount}
            setMount={setMount}
            getQuotesDetailData={getQuotesDetailData}
            quoteShareclick={quoteShareclick}
            showsharedDetails={showsharedDetails}
            gridData={gridData}
            isLoading={isLoading}
            selectedItem={selectedItem}
            setSelectedItem={setSelectedItem}
            addToCart={addToCart} share={share}
            archiveQuote={archiveQuote}
            onSelectionChange={onSelectionChange}
            selectAll={selectAll}
            quoteShareClick={quoteShareClick}
            onCommentChange={onCommentChange}
            quoteDetailList={quoteDetailList}
            decrementCount={decrementCount}
            incrementCount={incrementCount}
            updateCheckedItems={updateCheckedItems}
            onQuoteClick={onQuoteClick}
            selectedDetailItem={selectedDetailItem}
            shareQuoteRes={shareQuoteRes}
            deleteOrArchiveQuoteRes={deleteOrArchiveQuoteRes}
            saveQuoteRes={saveQuoteRes}
            addToCartQuoteRes={addToCartQuoteRes}
            showAlert={showAlert}
            showPopup={showPopup}
            isShowSavePopup={isShowSavePopup}
            quoteShareClickBack={quoteShareClickBack}
            errorSuccessMessage={errorSuccessMessage}
            alertType={alertType}
            handleAlertClose={handleAlertClose}
            openSharePopup={openSharePopup}
            shareQuoteService={shareQuoteService}
            deleteOrArchiveQuote={deleteOrArchiveQuote}
            saveQuote={saveQuote}
            addToCartQuote={addToCartQuote}
            excelExport={excelExport}
            handleLinkClick={handleLinkClick}
            shareQuote={shareQuote}
            saveQuoteService={saveQuoteService}
            handleIsShowSavePopup={handleIsShowSavePopup}
            showShareAlert={showShareAlert}
            setShowShareAlert={setShowShareAlert}
            errorShareMsg={errorShareMsg}
            setErrorShareMsg={setErrorShareMsg}
            tab={tab}
            archivetab={archivetab}
            onRefresh={props.onRefresh}
            selectedKey={selectedKey}
            downloadAttachment={downloadAttachment}
            onQuantityChange={onQuantityChange}
            redirectErrorMsg={redirectErrorMsg}
            handleRedirectAlertClose={handleRedirectAlertClose}
        />
    )
}

export default Quotescontainer